// extracted by mini-css-extract-plugin
export default {"navheader":"NavHeader_navheader__QrxOF","navbutton":"NavHeader_navbutton__UxRTX"};